// extracted by mini-css-extract-plugin
module.exports = {"mypage_common_menu_wrap":"menu_mypage_common_menu_wrap__3RJB1","mypage_common_menu":"menu_mypage_common_menu__2tiuE"};